module.exports = __webpack_public_path__ + "static/media/COLA2018005.b2951eae.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/PDFFiles/COLA2018005.pdf
// module id = 1929
// module chunks = 1